import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { UserListComponent } from '../admin-management/components/user-list/user-list.component';
import { NgBootstrapModule } from '@app/commons/ng-bootstrap.module';
import { bearerTokenInterceptor, sessionEndCheckInterceptor } from '@app/commons/interceptors/auth.interceptor';
import { ComponentsModule } from '@app/components/components.module';
import { AdminManagementRoutingModule } from './admin-management-routing.module';
import { AdminManagementComponent } from './container/admin-management/admin-management.component';
import { ChatbotDetailComponent } from './container/chatbot-detail/chatbot-detail.component';
import { ChatbotListComponent } from './container/chatbot-list/chatbot-list.component';
import { CustomEventHandler } from '@app/commons/utils/event-handler';
import { SharedModule } from '@app/commons/sharad.module';

@NgModule({
  declarations: [
    UserListComponent,
    AdminManagementComponent,
    ChatbotDetailComponent,
    ChatbotListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AdminManagementRoutingModule,
    NgBootstrapModule,
    ComponentsModule,
    SharedModule
  ],
  providers: [
    provideHttpClient(withInterceptors([bearerTokenInterceptor, sessionEndCheckInterceptor])),
    CustomEventHandler
  ],
  exports: []
})
export class AdminManagementModule { }
